import styles from '../sass/definitions/_sizes.scss';

export const remToPixelRatio = 10;

export const GlobalStyleConstants = Object.freeze({
  TUNER_BAR_HEIGHT: parseFloat(styles.TUNER_BAR_HEIGHT) * remToPixelRatio,
  TOP_BAR_HEIGHT: parseFloat(styles.TOP_BAR_HEIGHT) * remToPixelRatio,
  TOP_BAR_HEIGHT_MIN_WIDTH: parseFloat(styles.TOP_BAR_HEIGHT_MIN_WIDTH) * remToPixelRatio,
  GRID_ITEM_FOOTER_HEIGHT: parseFloat(styles.GRID_ITEM_FOOTER_HEIGHT) * remToPixelRatio,
});
